/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nudge_Upload_Person_Document_TitleInputs */



/**
* | output |
* | --- |
* | "Documents" |
*
* @param {Nudge_Upload_Person_Document_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const nudge_upload_person_document_title = /** @type {((inputs?: Nudge_Upload_Person_Document_TitleInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nudge_Upload_Person_Document_TitleInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Documenten")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Documents")
	return /** @type {LocalizedString} */ ("Documents")
});